// extracted by mini-css-extract-plugin
module.exports = {"root":"_792376","icon":"_89da2c","tealIcon":"_5ed9e0","title":"_b5d5dc"};